module.exports = __webpack_public_path__ + "./workspace-pic01_75b277421e72fa8fe05373d36f9afe6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/workspace-pic01.jpg
// module id = 634
// module chunks = 0